import React from 'react';
import PropTypes from 'prop-types';
import ModalView from '../modalView';

import '../style.sass';

const CreateCategory = (props) => {
  const { t } = props;
  return (
    <ModalView
      title={t('Create new category')}
      titleAction={t('Create')}
      {...props}
    />
  );
};

CreateCategory.propTypes = {
  t: PropTypes.func.isRequired,
};

export default CreateCategory;
